import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const EmojiHappy = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g>
        <g>
          <path
            d="M9 22.4077H15C20 22.4077 22 20.4077 22 15.4077V9.40771C22 4.40771 20 2.40771 15 2.40771H9C4 2.40771 2 4.40771 2 9.40771V15.4077C2 20.4077 4 22.4077 9 22.4077Z"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15.5 10.1577C16.3284 10.1577 17 9.48614 17 8.65771C17 7.82929 16.3284 7.15771 15.5 7.15771C14.6716 7.15771 14 7.82929 14 8.65771C14 9.48614 14.6716 10.1577 15.5 10.1577Z"
            stroke={stroke}
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.5 10.1577C9.32843 10.1577 10 9.48614 10 8.65771C10 7.82929 9.32843 7.15771 8.5 7.15771C7.67157 7.15771 7 7.82929 7 8.65771C7 9.48614 7.67157 10.1577 8.5 10.1577Z"
            stroke={stroke}
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.4 13.7075H15.6C16.1 13.7075 16.5 14.1075 16.5 14.6075C16.5 17.0975 14.49 19.1075 12 19.1075C9.51 19.1075 7.5 17.0975 7.5 14.6075C7.5 14.1075 7.9 13.7075 8.4 13.7075Z"
            stroke={stroke}
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  );
};

EmojiHappy.displayName = 'EmojiHappy';
